import { Report19201Container } from "../../../containers/borrowSystem/Report/Report19201Container";

export function Report19201Page() {
    return (
        <Report19201Container />
    )
}